import { EventBus } from '../../plugins/event-bus'
import {
  callCheckForUpdates,
  callGetCloudPost,
  callSendContactForm,
  callSaveCloudpage,
  callLogPostView,
  callLogCTAClick,
  callUpsertAdmin,
  callGetHomePosts,
  callDeleteAdmin,
  callSendNewsletterSignUp,
  callUpdateAutoNewsletter,
  callGetAutoNewsletterStatus,
  callTurnOffAutoNewsletter,
  updateCloudAutoModeStatus,
  callUpdatePost,
  callDeletePost,
  callGetSchools,
  callSendConnectionParentRegistration,
} from '../../api/careerwise.js'
import {
  mapCloudPostTags,
  mapList,
  reduceListsHail,
  mapFollower,
  triggerAlert,
  triggerErrorGeneric,
  isSuccessResponse,
} from '../util.js'

// SETTINGS
export function dispatchSetCurrentLayout1HomeTemplate(context, data) {
  try {
    context.commit('UPDATE_CURRENT_LAYOUT1_HOME_TEMPLATE_ID', data)
  } catch {
    triggerErrorGeneric()
  }
}

export async function dispatchContactFormEmail(_context, payload = null) {
  try {
    const response = await callSendContactForm(payload)
    if (isSuccessResponse(response)) {
      EventBus.$emit('triggerAlertResponse', response.data?.alert)
      return response.data.success
    }
  } catch {
    triggerErrorGeneric()
  }
}

export async function dispatchUpsertAdmin(_context, data) {
  try {
    const admin = await callUpsertAdmin(data)
    if (admin) {
      return admin
    }
  } catch {
    triggerErrorGeneric()
  }
}

export async function dispatchDeleteAdmin(context, data) {
  try {
    const response = await callDeleteAdmin(data)
    if (response.data?.success) {
      EventBus.$emit('triggerAlertResponse', response.data?.alert)
      EventBus.$emit('reloadWebsiteSettings')
    }
  } catch {
    triggerErrorGeneric()
  }
}

export function dispatchSetTVMode(context, data) {
  try {
    context.commit('UPDATE_TV_MODE', data)
  } catch {
    triggerErrorGeneric()
  }
}

// TENANT POSTS
export async function dispatchUpdateHomePosts(context, payload = null) {
  try {
    const response = await callGetHomePosts(payload)

    if (isSuccessResponse(response)) {
      const data = response.data.data
      context.commit('UPDATE_HOME_POSTS', data.posts)

      return {
        emptyTags: data.emptyTags,
        emptyCategories: data.emptyCategories,
      }
    }

    triggerAlert(response)
    return response?.data?.data || null
  } catch {
    triggerErrorGeneric()
  }
}

// MIGRATIONS/HOOTMAIL
export async function dispatchCheckForUpdates(context) {
  try {
    const tenantId = context.rootGetters['shared/getTenantId']
    const response = await callCheckForUpdates(tenantId)

    if (response?.data?.success) {
      context.commit('UPDATE_UPDATES_REQUIRED_COUNT', response.data.updates)
    }
  } catch {
    triggerErrorGeneric()
  }
}

export async function dispatchRedirectForUpdates(context, data) {
  try {
    // Redirect tenant to Hootmail if required migrations have not been run
    const client = context.rootGetters['shared/getClient']
    if (client === 'client1tenant') {
      const missingUpdates = context.rootGetters['shared/getMigrationsMissing']
      const isLocked = data?.updatesRequired?.some((requiredUpdate) =>
        missingUpdates?.includes(requiredUpdate),
      )

      if (isLocked) {
        EventBus.$emit('showModal', 'cw-tenant-migration-status')
        data?.router.push({ path: '/manager/hootmail' })
      }
    }
  } catch {
    triggerErrorGeneric()
  }
}

// POSTS
export async function dispatchUpdatePost(_context, payload) {
  try {
    const response = await callUpdatePost(payload)
    if (response.data?.success) {
      EventBus.$emit('update_post_success', payload.post_id)
    }
    if (response.data?.alert) {
      EventBus.$emit('triggerAlertResponse', response.data?.alert)
    }
  } catch {
    triggerErrorGeneric()
  }
}

export async function dispatchDeletePost(_context, id) {
  try {
    const response = await callDeletePost(id)
    if (response.data?.success) {
      // @todo PAGE delete send message from backend
      EventBus.$emit('triggerAlertResponse', response.data?.alert)
      EventBus.$emit('post-delete', response)
    }
  } catch {
    triggerErrorGeneric()
  }
}

export async function dispatchLogPostView(context, data) {
  try {
    callLogPostView(data)
  } catch {
    triggerErrorGeneric()
  }
}

export async function dispatchLogCTAClick(context, data) {
  try {
    callLogCTAClick(data)
  } catch {
    triggerErrorGeneric()
  }
}

// CLOUD
export async function dispatchSetCurrentCloudPost(context, data = null) {
  try {
    if (data) {
      const response = await callGetCloudPost(data)

      if (response?.data?.success) {
        // handle tags
        const tag_titles = response.data.post.tag_titles
        const tagsGeneral = context.rootGetters['shared/getSettings']?.tags
        const tagsIndustries =
          context.rootGetters['shared/getSettings']?.tag_industries
        const tagsYears = context.rootGetters['shared/getSettings']?.tag_years
        const tagsRegions =
          context.rootGetters['shared/getSettings']?.tag_regions

        response.data.post.general_tags = mapCloudPostTags(
          tagsGeneral,
          tag_titles,
        )
        response.data.post.industry_tags = mapCloudPostTags(
          tagsIndustries,
          tag_titles,
        )
        response.data.post.year_tag = mapCloudPostTags(tagsYears, tag_titles)
        response.data.post.region_tag = mapCloudPostTags(
          tagsRegions,
          tag_titles,
        )

        context.commit('UPDATE_CURRENT_CLOUD_POST', response.data.post)
        EventBus.$emit('newPostData')
        return true
      }

      return false
    } else {
      context.commit('CLEAR_CURRENT_CLOUD_POST')
      return true
    }
  } catch {
    triggerErrorGeneric()
  }
}

// @todo LibraryPageCard
// @todo set_saved_cloudposts
export async function dispatchSaveCloudpage(context, data) {
  try {
    if (data) {
      // @todo in LibraryPageCard
      // const tenantId = context.rootGetters['shared/getTenantId']
      // if (data.tenantId === tenantId || this.saved)
      const payload = {
        post_id: data.id,
      }

      const response = await callSaveCloudpage(payload)

      if (response?.data?.success) {
        if (response.data.saved) {
          context.commit('UPDATE_SAVED_CLOUDPOSTS', response.data.saved)
        }

        EventBus.$emit('CloneResponseReceived')
        return true
      }

      EventBus.$emit('triggerAlertResponse', {
        status: 'error',
        message: 'Failed to save page',
      })
      return false
    }

    return true
  } catch {
    triggerErrorGeneric()
  }
}

// @todo Tenant1Library: callGetLibraryPosts
// @todo Tenant1Cloud: callGetCloudPosts
// @todo set_saved_cloudposts
export async function dispatchGetPosts(context, data) {
  try {
    if (data) {
      const payload = data
      const response = await data.requestType(payload)

      if (response?.data?.success) {
        if (response.data.saved) {
          context.commit('UPDATE_SAVED_CLOUDPOSTS', response.data.saved)
        }

        return true
      }

      return false
    }

    return true
  } catch {
    triggerErrorGeneric()
  }
}

export function dispatchSetCloudTenantLeaders(context, data) {
  try {
    if (data) {
      context.commit('UPDATE_CLOUD_TENANT_LEADERS', data)
    }
  } catch {
    triggerErrorGeneric()
  }
}

export function dispatchSetFilterCloudBy(context, data) {
  try {
    if (data) {
      context.commit('UPDATE_FILTER_CLOUD_BY', data)
    }
  } catch {
    triggerErrorGeneric()
  }
}

// MAIL

export async function dispatchNewsletterSignUp(_context, payload) {
  try {
    const response = await callSendNewsletterSignUp(payload)

    if (isSuccessResponse(response)) {
      return true
    }

    triggerAlert(response)
  } catch {
    triggerErrorGeneric()
  }
}

export async function dispatchInitFollowers(context, initHail = false) {
  await context.dispatch('dispatchGetMailLists')
  await context.dispatch('dispatchGetFollowers')
  await context.dispatch('dispatchGetUnsubscribedFollowers')

  if (initHail) {
    await context.dispatch('dispatchGetMailListsHail')
  }
}

/**
 * Get all Hail mail lists/groups.
 *
 * @param {Object} context state context
 */
export async function dispatchGetMailListsHail(context) {
  try {
    context.commit('UPDATE_MAIL_LISTS_HAIL', [])
    const response = await axios.get('/api/auth/get-hail-mailing-lists')
    let data = {}

    if (response.data?.success) {
      data = response.data.lists.reduce(reduceListsHail, {})
    }

    context.commit('UPDATE_MAIL_LISTS_HAIL', data)

    if (response.data?.alert) {
      EventBus.$emit('triggerAlertResponse', response.data.alert)
    }
  } catch {
    triggerErrorGeneric()
  }
}

/**
 * Get all mail lists/groups.
 *
 * @param {Object} context state context
 */
export async function dispatchGetMailLists(context) {
  try {
    context.commit('UPDATE_MAIL_LISTS', [])
    const response = await axios.get('/api/auth/get-mail-lists')
    let data = []

    if (response.data?.success) {
      data =
        response.data.lists?.map((list) => {
          return {
            ...mapList(list),
            actions: true,
          }
        }) || []
    }

    context.commit('UPDATE_MAIL_LISTS', data)
    EventBus.$emit('setLists')

    if (response.data?.alert) {
      EventBus.$emit('triggerAlertResponse', response.data.alert)
    }
  } catch {
    triggerErrorGeneric()
  }
}

/**
 * Create a new mail list/group.
 *
 * @param {Object} context state context
 * @param {Object} payload mail list details
 */
export async function dispatchCreateMailList(context, payload) {
  try {
    const response = await axios.post('/api/auth/create-mail-list', payload)

    if (response.data?.success) {
      await context.dispatch('dispatchGetMailLists')
      const activeListId = context.getters.getMailListLatestId
      if (activeListId) {
        EventBus.$emit('setActiveListId', activeListId)
      }
    }
    if (response.data?.alert) {
      EventBus.$emit('triggerAlertResponse', response.data.alert)
    }
  } catch {
    triggerErrorGeneric()
  }
}

/**
 * Update an existing mail list/group.
 *
 * @param {Object} context state context
 * @param {Object} payload mail list details
 */
export async function dispatchUpdateMailList(context, payload) {
  try {
    const response = await axios.post('/api/auth/update-mail-list', payload)

    if (response.data?.success) {
      await context.dispatch('dispatchGetMailLists')
      EventBus.$emit('setActiveListId', payload.id)
    }

    if (response.data?.alert) {
      EventBus.$emit('triggerAlertResponse', response.data.alert)
    }
  } catch {
    triggerErrorGeneric()
  }
}

/**
 * Delete an existing mail list/group.
 *
 * @param {Object} context state context
 * @param {Object} payload includes id field of list to delete, e.g., { id: 0 }
 */
export async function dispatchDeleteMailList(context, payload) {
  try {
    const response = await axios.post('/api/auth/delete-mail-list', payload)
    if (response.data?.alert) {
      EventBus.$emit('triggerAlertResponse', response.data.alert)
    }
    if (response.data?.success) {
      EventBus.$emit('initSubscribers')
      EventBus.$emit('setLists')
    }
  } catch {
    triggerErrorGeneric()
  }
}

/**
 * Delete an existing mail list/group.
 *
 * @param {Object} context state context
 * @param {Object} payload includes array of ids of list to export [1, 2]
 */
export async function dispatchExportMailListFollowers(context, payload) {
  try {
    const response = await axios.post('/api/auth/export-list', payload)

    if (response.data) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'careerwise-list-export.csv') // set the filename
      document.body.appendChild(link)
      link.click()
    }

    if (response.data?.alert) {
      EventBus.$emit('triggerAlertResponse', response.data.alert)
    }
  } catch {
    triggerErrorGeneric()
  }
}

/**
 * Get all followers from all or specific mail list(s)/group(s).
 *
 * @param {Object} context state context
 * @param {Object} payload includes optional list id(s) array to get followers from
 */
export async function dispatchGetFollowers(context, payload) {
  try {
    context.commit('UPDATE_FOLLOWERS', [])
    payload = payload || null
    const response = await axios.post('/api/auth/get-followers', payload)
    let data = []

    if (response.data?.success) {
      data =
        response.data.followers?.map((follower) => {
          const status = follower.bounced
            ? 'bounced'
            : parseInt(follower.subscribe)
            ? 'subscribed'
            : 'unsubscribed'
          return mapFollower(follower, status)
        }) || []
    }

    context.commit('UPDATE_FOLLOWERS', data)

    if (response.data?.alert) {
      EventBus.$emit('triggerAlertResponse', response.data.alert)
    }
  } catch {
    triggerErrorGeneric()
  }
}

/**
 * Get all unsubscribed (bounced/listless) followers from all list(s)/group(s).
 *
 * @param {Object} context state context
 */
export async function dispatchGetUnsubscribedFollowers(context, payload) {
  try {
    const response = await axios.get(
      '/api/auth/get-unsubscribed-followers',
      payload,
    )

    if (response.data?.success) {
      const bounced = response.data.bounced.map((follower) =>
        mapFollower(follower, 'bounced'),
      )
      const listless = response.data.listless.map((follower) =>
        mapFollower(follower, 'unlisted'),
      )
      context.commit('UPDATE_FOLLOWERS_BOUNCED', bounced)
      context.commit('UPDATE_FOLLOWERS_LISTLESS', listless)
    }

    if (response.data?.alert) {
      EventBus.$emit('triggerAlertResponse', response.data.alert)
    }
  } catch {
    triggerErrorGeneric()
  }
}

/**
 * Update mail lists for new/existing follower(s).
 *
 * @param {Object} context state context
 * @param {Object} payload expects array of `followers` object(s), including `mail_list` ids:
 * e.g., payload.followers = [{email: 'test@test.com', mail_lists: [1,2]}]
 */
export async function dispatchUpdateFollowers(context, payload) {
  try {
    const response = await axios.post('/api/auth/update-followers', payload)

    if (response.data?.alert) {
      EventBus.$emit('triggerAlertResponse', response.data.alert)
    }
    if (response.data?.success) {
      EventBus.$emit('triggerListAlert')
    }
  } catch {
    triggerErrorGeneric()
  }
}

/**
 * Remove existing follower(s) from existing list (but leaving follower in the system).
 *
 * @param {Object} context state context
 * @param {Object} payload includes array of `follower_ids` to remove
 */
export async function dispatchRemoveFollowersFromList(context, payload) {
  try {
    const response = await axios.post(
      '/api/auth/remove-followers-from-list',
      payload,
    )

    if (response.data?.alert) {
      EventBus.$emit('triggerAlertResponse', response.data.alert)
    }
    if (response.data?.success) {
      EventBus.$emit('triggerListAlert')
    }
  } catch {
    triggerErrorGeneric()
  }
}

/**
 * Deletes follower(s) from the system and removes all relationships.
 *
 * @param {Object} context state context
 * @param {Object} payload includes array of `follower_ids` to delete
 */
export async function dispatchDeleteFollowers(context, payload) {
  try {
    const response = await axios.post('/api/auth/delete-followers', payload)
    if (response.data?.alert) {
      EventBus.$emit('triggerAlertResponse', response.data.alert)
    }
    if (response.data?.success) {
      EventBus.$emit('triggerListAlert')
    }
  } catch {
    triggerErrorGeneric()
  }
}

/**
 * Gets posts for attaching to newsletter.
 *
 * @param {Object} context state context
 * @param {Object} payload
 */
export async function dispatchGetNewsletterPosts(context, payload = null) {
  const response = await axios.post('/api/auth/get-newsletter-posts', payload)
  if (response.data?.success) {
    context.commit('UPDATE_NEWSLETTER_POSTS', response.data.posts)
    return response.data.pagination
  } else {
    context.commit('UPDATE_NEWSLETTER_POSTS', []) // you still suck
    return null
  }
}

/**
 * Gets newsletters that have been sent, scheduled or saved as draft.
 *
 * @param {Object} context state context
 * @param {Object} payload
 */
export async function dispatchGetNewsletters(context, payload = null) {
  const response = await axios.post(
    '/api/auth/get-sent-hail-newsletters',
    payload,
  )
  if (response.data?.success) {
    return response
  } else {
    return null
  }
}

/**
 * Gets the campaign stats from Hail/SES.
 *
 * @param {Object} context state context
 * @param {Object} payload { email: 'subscriberEmail' }
 */
export async function dispatchGetSubscriberCampaignStats(context, payload) {
  const response = await axios.post('/api/auth/get-campaign-activity', payload)

  return (response.data?.campaign_activity || []).map((campaign) => {
    const newsletter = campaign.newsletter
      ? {
          id: campaign.newsletter.id,
          title: campaign.newsletter.title,
          subject: campaign.newsletter.subject,
          blurb: campaign.newsletter.blurb,
          sentAt: campaign.newsletter.sent_at,
          createdAt: campaign.newsletter.created_at,
          updatedAt: campaign.newsletter.updated_at,
          information: {
            postIds: campaign.newsletter.information?.post_ids,
            mailLists: campaign.newsletter.information?.mail_lists,
          },
          hailCampaignId: campaign.newsletter.hail_campaign_id,
        }
      : null
    return {
      clickedAt: campaign.clicked_at,
      openedAt: campaign.opened_at,
      campaignStatus: campaign.campaign_status,
      newsletter,
    }
  })
}

/**
 * Gets the campaign stats from Hail/SES.
 *
 * @param {Object} context state context
 * @param {Object} payload
 */
export async function dispatchGetHailCampaign(context, payload = null) {
  const response = await axios.post('/api/auth/get-hail-campaign', payload)
  if (response.data?.success) {
    return response
  } else {
    return null
  }
}

/**
 * Gets posts that were from within a newsletter.
 *
 * @param {Object} context state context
 * @param {Object} payload
 */
export async function dispatchGetPostsFromSentNewsletter(
  context,
  payload = null,
) {
  const response = await axios.post(
    '/api/auth/get-posts-from-newsletter',
    payload,
  )
  if (response.data?.success) {
    return response
  } else {
    return null
  }
}

/**
 * Sends a newsletter to selected lists.
 *
 * @param {Object} context state context
 */
export async function dispatchSendNewsletter(context, payload = null) {
  const response = await axios.post('/api/auth/send-hail-newsletter', payload)
  if (response.data?.alert) {
    EventBus.$emit('triggerAlertResponse', response.data.alert)
  }

  return response.data?.success || false
}

/**
 * Sets or resets selected posts for the newsletter.
 *
 * @param {Object} context state context
 * @param {Array} payload array of selected newsletter post objects
 */
export async function dispatchUpdateSelectedNewsletterPosts(context, payload) {
  if (payload) {
    // update selected posts
    context.commit('UPDATE_NEWSLETTER_SELECTED_POSTS', payload)
  } else {
    // reset selected posts
    context.commit('CLEAR_NEWSLETTER_SELECTED_POSTS')
  }
}

/**
 * Gets newsletter for public view
 *
 * @param {Object} context state context
 * @param {Object} payload
 */
export async function dispatchGetPublicNewsletter(context, id) {
  const response = await axios.get('/api/newsletter/' + id)
  if (response.data?.success) {
    return response
  } else {
    return null
  }
}

/**
 * Update the status of the automatic newsletter
 *
 * @param {object} context
 * @param {object} payload includes
 * @returns {boolean} api success/failure
 */
export async function dispatchUpdateAutoNewsletter(context, payload) {
  try {
    const response = await callUpdateAutoNewsletter(payload)

    return !!response?.data?.success
  } catch {
    triggerErrorGeneric()
  }
}

/**
 *  Returns the status of the automatic newsletter
 *
 * @param {object} context
 * @param {object} payload includes
 * @returns {boolean} api success/failure
 */
export async function dispatchGetAutoNewsletterStatus(context) {
  try {
    const response = await callGetAutoNewsletterStatus()
    if (response?.data?.success) {
      context.commit('UPDATE_AUTO_NEWSLETTER_STATUS', response.data.data)
    }

    return !!response?.data?.success
  } catch {
    triggerErrorGeneric()
  }
}

/**
 * Turns off the auto newsletter
 *
 * @param {object} context
 * @returns {boolean} api success/failure
 */
export async function dispatchTurnOffAutoNewsletter(context) {
  try {
    const response = await callTurnOffAutoNewsletter()

    if (response?.data?.success) {
      context.commit('CLEAR_AUTO_NEWSLETTER_STATUS')
    }

    return !!response?.data?.success
  } catch {
    triggerErrorGeneric()
  }
}

/**
 * Turns off the auto newsletter
 *
 * @param {object} context
 * @param {object} payload
 * @returns {boolean} api success/failure
 */
export async function dispatchUpdateCloudAutoModeStatus(context, payload) {
  try {
    const response = await updateCloudAutoModeStatus(payload)

    return !!response?.data?.success
  } catch {
    triggerErrorGeneric()
  }
}

/**
 * Saves posts from the cloud to CW tenants
 *
 * @param {Object} context state context
 * @param {Object} payload
 */
export async function dispatchSaveCloudPost(context, payload = null) {
  if (context.rootState.shared.settings.audience < 1) {
    EventBus.$emit('triggerAlertResponse', {
      status: 'error',
      message: 'Update your school audience to save posts.',
    })
    return
  }
  const response = await axios.post(
    '/api/auth/manager-cloud-post-save',
    payload,
  )
  if (response.data?.alert) {
    EventBus.$emit('triggerAlertResponse', response.data.alert)
  }
  if (response.data?.saved) {
    context.commit('UPDATE_SAVED_CLOUDPOSTS', response.data.saved)
  }

  return !!response.data?.success
}

/**
 * Fetches a list of schools from the API.
 *
 * This function makes an API call to fetch a list of schools. If the API call is successful, it commits a mutation to update the schools list in the state. If the API call fails, it commits a mutation to clear the schools list in the state.
 *
 * @param {object} context state context
 * @returns {boolean} api success/failure
 */
export async function dispatchGetSchools(context) {
  try {
    const response = await callGetSchools()
    if (response.data?.success) {
      const data = response.data?.data
        ?.map((school) => {
          return {
            value: school.id,
            id: school.id,
            label: school.profile_title,
            domain: school.domain,
          }
        })
        .sort((a, b) => a.label.localeCompare(b.label))
      context.commit('UPDATE_SCHOOLS_LIST', data)
    } else {
      context.commit('CLEAR_SCHOOLS_LIST')
    }

    return !!response?.data?.success
  } catch (error) {
    triggerErrorGeneric()
  }
}

/**
 * Sends a connection parent registration request to the API.
 *
 * This function makes an API call to send a connection parent registration request. If the API call is successful and an alert message is returned, it emits an event to trigger an alert response.
 *
 * @param {object} _context state context
 * @param {object} payload Payload for enquiry
 * @returns {boolean} api success/failure
 */
export async function dispatchSendConnectionParentRegistration(
  _context,
  payload,
) {
  try {
    const response = await callSendConnectionParentRegistration(payload)

    if (response.data?.alert) {
      EventBus.$emit('triggerAlertResponse', response.data.alert)
    }
    return !!response?.data?.success
  } catch (error) {
    triggerErrorGeneric()
  }
}
